<template>
  <div>
    <PageHeader page-name="Статистика адміністраторів" />
    <List />
  </div>
</template>

<script>

import List from '@/components/admin-statistics/List'
import PageHeader from '@/components/common/PageHeader';

export default {
  components: {List, PageHeader},
}
</script>

<style scoped>

</style>
